/**
 * Checks if a branch's Registration Expiry Date (RegExpiryDate) is within 6 months (approx 183 days) or expired.
 * @param {object} branch - Branch object from state/localStorage
 * @returns {object|null} - Expiry alert details or null if valid / > 6 months
 */
export const checkRegistrationExpiry = (branch) => {
  if (!branch || !branch.RegExpiryDate) return null;

  const raw = String(branch.RegExpiryDate).trim();
  if (!raw || raw === "null" || raw === "undefined") return null;

  let expiryDate = null;

  // Handle MS JSON Date format: /Date(1234567890)/
  if (raw.includes("/Date(")) {
    const timestamp = parseInt(raw.replace(/\/Date\((\d+)\)\//, "$1"), 10);
    if (!isNaN(timestamp)) expiryDate = new Date(timestamp);
  } else {
    // Handle DD/MM/YYYY or DD-MM-YYYY
    const ddmmyyyyMatch = raw.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
    if (ddmmyyyyMatch) {
      const day = parseInt(ddmmyyyyMatch[1], 10);
      const month = parseInt(ddmmyyyyMatch[2], 10) - 1;
      const year = parseInt(ddmmyyyyMatch[3], 10);
      expiryDate = new Date(year, month, day);
    } else {
      const parsed = new Date(raw);
      if (!isNaN(parsed.getTime())) expiryDate = parsed;
    }
  }

  if (!expiryDate || isNaN(expiryDate.getTime())) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const exp = new Date(expiryDate);
  exp.setHours(0, 0, 0, 0);

  const diffTime = exp.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // 6 months is approx 183 days
  const isExpiringWithin6Months = diffDays <= 183;
  const isExpired = diffDays < 0;

  if (!isExpiringWithin6Months) {
    return null; // More than 6 months away, no alert needed
  }

  const formattedDate = exp.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return {
    isExpired,
    isExpiringWithin6Months: true,
    diffDays: Math.abs(diffDays),
    daysRemaining: diffDays >= 0 ? diffDays : 0,
    daysOverdue: diffDays < 0 ? Math.abs(diffDays) : 0,
    expiryDate: exp,
    formattedDate,
    rawDate: raw,
    branchName: branch.Name || "Active Branch",
    fbRegNo: branch.FBRegNo || "",
  };
};
